// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment-status-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  text-align: center;
  padding: 20px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}
.payment-status-page h1 {
  margin-bottom: 20px;
  font-weight: 700;
  color: #2c3e50;
}
.payment-status-page p {
  margin-bottom: 20px;
  color: #5a6c7d;
  font-size: 16px;
  line-height: 1.6;
}
.payment-status-page Button {
  font-size: 16px;
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 600;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
.payment-status-page Button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.payment-failure .failure-icon-container {
  margin-bottom: 30px;
}
.payment-failure .failure-icon-container .failure-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 120px;
  height: 120px;
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%);
  border-radius: 50%;
  box-shadow: 0 8px 25px rgba(220, 53, 69, 0.3);
  animation: pulse 2s infinite;
}
.payment-failure .failure-icon-container .failure-icon svg {
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
}
.payment-failure .failure-title {
  font-size: 2.5rem;
  font-weight: 800;
  color: #dc3545;
  margin-bottom: 20px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.payment-failure .failure-message {
  max-width: 500px;
  margin-bottom: 40px;
}
.payment-failure .failure-message p {
  font-size: 18px;
  color: #495057;
  background: rgba(255, 255, 255, 0.8);
  padding: 20px;
  border-radius: 12px;
  border-left: 4px solid #dc3545;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
}
.payment-failure .failure-actions {
  margin-bottom: 30px;
}
.payment-failure .failure-actions .retry-button {
  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
  border: none;
  padding: 15px 30px;
  font-size: 18px;
  font-weight: 600;
  border-radius: 12px;
  box-shadow: 0 6px 20px rgba(220, 53, 69, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 200px;
}
.payment-failure .failure-actions .retry-button:hover {
  background: linear-gradient(135deg, #c82333 0%, #bd2130 100%);
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(220, 53, 69, 0.4);
}
.payment-failure .failure-actions .retry-button:active {
  transform: translateY(-1px);
}
.payment-failure .failure-help .help-text {
  font-size: 14px;
  color: #6c757d;
  font-style: italic;
  margin: 0;
  opacity: 0.8;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    box-shadow: 0 8px 25px rgba(220, 53, 69, 0.3);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 12px 35px rgba(220, 53, 69, 0.4);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 8px 25px rgba(220, 53, 69, 0.3);
  }
}
@media (max-width: 768px) {
  .payment-status-page {
    padding: 15px;
  }
  .payment-status-page h1 {
    font-size: 2rem;
  }
  .payment-status-page p {
    font-size: 16px;
  }
  .payment-failure .failure-icon-container .failure-icon {
    width: 100px;
    height: 100px;
  }
  .payment-failure .failure-icon-container .failure-icon svg {
    width: 60px;
    height: 60px;
  }
  .payment-failure .failure-title {
    font-size: 2rem;
  }
  .payment-failure .failure-message p {
    font-size: 16px;
    padding: 15px;
  }
  .payment-failure .failure-actions .retry-button {
    padding: 12px 24px;
    font-size: 16px;
    min-width: 180px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Student/PaymentForm/PaymentSuccess.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,6DAAA;AACF;AACE;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;AACJ;AAEE;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAAJ;AAGE;EACE,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,wCAAA;AADJ;AAGI;EACE,2BAAA;EACA,0CAAA;AADN;;AAQE;EACE,mBAAA;AALJ;AAOI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,6DAAA;EACA,kBAAA;EACA,6CAAA;EACA,4BAAA;AALN;AAOM;EACE,iDAAA;AALR;AAUE;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,yCAAA;AARJ;AAWE;EACE,gBAAA;EACA,mBAAA;AATJ;AAWI;EACE,eAAA;EACA,cAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,yCAAA;EACA,2BAAA;AATN;AAaE;EACE,mBAAA;AAXJ;AAaI;EACE,6DAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,6CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAXN;AAaM;EACE,6DAAA;EACA,2BAAA;EACA,6CAAA;AAXR;AAcM;EACE,2BAAA;AAZR;AAkBI;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;AAhBN;;AAsBA;EACE;IACE,mBAAA;IACA,6CAAA;EAnBF;EAqBA;IACE,sBAAA;IACA,8CAAA;EAnBF;EAqBA;IACE,mBAAA;IACA,6CAAA;EAnBF;AACF;AAuBA;EACE;IACE,aAAA;EArBF;EAuBE;IACE,eAAA;EArBJ;EAwBE;IACE,eAAA;EAtBJ;EA4BI;IACE,YAAA;IACA,aAAA;EA1BN;EA4BM;IACE,WAAA;IACA,YAAA;EA1BR;EA+BE;IACE,eAAA;EA7BJ;EAiCI;IACE,eAAA;IACA,aAAA;EA/BN;EAoCI;IACE,kBAAA;IACA,eAAA;IACA,gBAAA;EAlCN;AACF","sourcesContent":[".payment-status-page {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  text-align: center;\n  padding: 20px;\n  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n\n  h1 {\n    margin-bottom: 20px;\n    font-weight: 700;\n    color: #2c3e50;\n  }\n\n  p {\n    margin-bottom: 20px;\n    color: #5a6c7d;\n    font-size: 16px;\n    line-height: 1.6;\n  }\n\n  Button {\n    font-size: 16px;\n    padding: 12px 24px;\n    border-radius: 8px;\n    font-weight: 600;\n    transition: all 0.3s ease;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n\n    &:hover {\n      transform: translateY(-2px);\n      box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n    }\n  }\n}\n\n// Payment Failure specific styles\n.payment-failure {\n  .failure-icon-container {\n    margin-bottom: 30px;\n\n    .failure-icon {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      width: 120px;\n      height: 120px;\n      background: linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%);\n      border-radius: 50%;\n      box-shadow: 0 8px 25px rgba(220, 53, 69, 0.3);\n      animation: pulse 2s infinite;\n\n      svg {\n        filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));\n      }\n    }\n  }\n\n  .failure-title {\n    font-size: 2.5rem;\n    font-weight: 800;\n    color: #dc3545;\n    margin-bottom: 20px;\n    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  }\n\n  .failure-message {\n    max-width: 500px;\n    margin-bottom: 40px;\n\n    p {\n      font-size: 18px;\n      color: #495057;\n      background: rgba(255, 255, 255, 0.8);\n      padding: 20px;\n      border-radius: 12px;\n      border-left: 4px solid #dc3545;\n      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n      backdrop-filter: blur(10px);\n    }\n  }\n\n  .failure-actions {\n    margin-bottom: 30px;\n\n    .retry-button {\n      background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);\n      border: none;\n      padding: 15px 30px;\n      font-size: 18px;\n      font-weight: 600;\n      border-radius: 12px;\n      box-shadow: 0 6px 20px rgba(220, 53, 69, 0.3);\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      min-width: 200px;\n\n      &:hover {\n        background: linear-gradient(135deg, #c82333 0%, #bd2130 100%);\n        transform: translateY(-3px);\n        box-shadow: 0 8px 25px rgba(220, 53, 69, 0.4);\n      }\n\n      &:active {\n        transform: translateY(-1px);\n      }\n    }\n  }\n\n  .failure-help {\n    .help-text {\n      font-size: 14px;\n      color: #6c757d;\n      font-style: italic;\n      margin: 0;\n      opacity: 0.8;\n    }\n  }\n}\n\n// Animation for the failure icon\n@keyframes pulse {\n  0% {\n    transform: scale(1);\n    box-shadow: 0 8px 25px rgba(220, 53, 69, 0.3);\n  }\n  50% {\n    transform: scale(1.05);\n    box-shadow: 0 12px 35px rgba(220, 53, 69, 0.4);\n  }\n  100% {\n    transform: scale(1);\n    box-shadow: 0 8px 25px rgba(220, 53, 69, 0.3);\n  }\n}\n\n// Responsive design\n@media (max-width: 768px) {\n  .payment-status-page {\n    padding: 15px;\n\n    h1 {\n      font-size: 2rem;\n    }\n\n    p {\n      font-size: 16px;\n    }\n  }\n\n  .payment-failure {\n    .failure-icon-container {\n      .failure-icon {\n        width: 100px;\n        height: 100px;\n\n        svg {\n          width: 60px;\n          height: 60px;\n        }\n      }\n    }\n\n    .failure-title {\n      font-size: 2rem;\n    }\n\n    .failure-message {\n      p {\n        font-size: 16px;\n        padding: 15px;\n      }\n    }\n\n    .failure-actions {\n      .retry-button {\n        padding: 12px 24px;\n        font-size: 16px;\n        min-width: 180px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
